import { memo } from 'react';
import { CALYPSO } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CallSettingsIcon() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "calling",
      size: "xxs",
      className: "m-right-1",
      color: CALYPSO
    }), /*#__PURE__*/_jsx("span", {
      className: "display-inline-block m-right-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "calling-ui-library.callee-select.call"
      })
    })]
  });
}
export default /*#__PURE__*/memo(CallSettingsIcon);